import script from "./ReviewList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewList.vue?vue&type=script&setup=true&lang=js"

import "./ReviewList.vue?vue&type=style&index=0&id=12e4170b&lang=css"
import "./ReviewList.vue?vue&type=style&index=1&id=12e4170b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e4170b"]])

export default __exports__